// file for configure constant to application
export const PATHAPP = '/app/';
export const BASEAPI = '/alfabravo-api/';
